export const meterDevicesModelGuids = ['Lavva-Power', 'Lavva-Double', 'Lavva-Switch16A', 'Lavva-Plug'];

export const storeMainLink = 'https://lavva.pl/sklep/';
